import classNames from 'classnames';
import {Link} from 'react-router-dom';

type TProfileMenuItemProps = {
  menuItem: IMenu & {color?: string};
};

const ProfileMenuItem = ({
  menuItem: {title, icon, color = 'color-primary', route},
}: TProfileMenuItemProps) => {
  return (
    <>
      <Link to={route} className="text-decoration-none">
        <div className="my-3 d-flex align-items-center w-100">
          <i className={classNames(color, icon)}></i>
          <small className="pe-3 color-gray-1">{title}</small>
        </div>
      </Link>
    </>
  );
};

export default ProfileMenuItem;
